import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import { Heading, Card, CardBody, Button } from "@pancakeswap-libs/uikit";
import useI18n from "hooks/useI18n";
import BigNumber from "bignumber.js/bignumber";
import { useAllHarvest } from "hooks/useHarvest";
import { getBalanceVemp } from "utils/VoteHarvest";
import useUserAccount from "hooks/useUserAccount";
import { getPendingVEMP } from "utils/farmHarvest";
import { useWalletModal } from "components/CustomMenu/WalletModal";
import CakeHarvestBalance from "./CakeHarvestBalance";
import CakeWalletBalance from "./CakeWalletBalance";
import { useFarms, useVempDetails } from "../../../state/hooks";
import { getBalanceNumber } from "../../../utils/formatBalance";
import CardValue from "./CardValue";

const StyledFarmStakingCard = styled(Card)`
  min-height: 376px;
  background: linear-gradient(
    162.44deg,
    #000000 49.97%,
    rgba(0, 0, 0, 0) 98.44%
  );
  border: 1px solid #ffffff;
  box-sizing: border-box;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
`;

const Label = styled.div`
  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 14px;
`;

const Actions = styled.div`
  margin-top: 24px;
`;
const FarmedStakingCard = ({ webInstance }) => {
  const vempDetails: any = useVempDetails();

  const [pendingTx, setPendingTx] = useState(false);
  const TranslateString = useI18n();
  const farmsWithBalance = [];
  const [vempBalance, setVempBalance] = useState();
  const [totalVempAmount, setTotalVempAmount] = useState<number>();
  const farmLp = useFarms();

  const { login, reset } = useUserAccount();
  const { onPresentConnectModal } = useWalletModal(login, reset);

  useEffect(() => {
    const interval = setInterval(async () => {
      if (webInstance) {
        Promise.all(
          farmLp.map(async (farm) =>
            getPendingVEMP(farm, farm.cheffAddress, farm.lpSymbol, webInstance)
          )
        )
          .then((result) => {
            const totalVemp: number = result.reduce(
              (accumulator: number, amount: any) =>
                Number(amount) + Number(accumulator)
            );
            setTotalVempAmount(totalVemp);
          })
          .catch((err) => {
            if (err) {
              setTotalVempAmount(0.0);
            }
          });
      }
    }, 1000);

    const getAllValues = async () => {
      const balance = await getBalanceVemp(webInstance);
      setVempBalance(balance);
    };
    getAllValues();
    return () => {
      clearInterval(interval);
    };
  }, [vempBalance, farmLp, webInstance]);

  const cakeBalance = getBalanceNumber(new BigNumber(vempBalance));
  const balancesWithValue = farmsWithBalance.filter(
    (balanceType) => balanceType.balance.toNumber() > 0
  );

  const { onReward } = useAllHarvest(
    balancesWithValue.map((farmWithBalance) => farmWithBalance.pid)
  );
  const harvestAllFarms = useCallback(async () => {
    setPendingTx(true);
    try {
      await onReward();
    } catch (error) {
      // TODO: find a way to handle when the user rejects transaction or it fails
    } finally {
      setPendingTx(false);
    }
  }, [onReward]);

  return (
    <StyledFarmStakingCard>
      <CardBody>
        <Heading
          style={{
            fontSize: "24px",
            fontWeight: 600,
            width: "224px",
            margin: "auto",
            marginBottom: "36px",
          }}
          size="xl"
        >
          {TranslateString(542, "Metaverse Staking")}
        </Heading>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "80%",
            gap: "10px",
            margin: "auto",
            marginBottom: "50px",
          }}
        >
          <Label style={{ fontSize: "20px", color: "white", fontWeight: 100 }}>
            VEMP to Loot
          </Label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: "20px",
              color: "white",
              fontWeight: 100,
            }}
          >
            <CakeHarvestBalance earningsSum={totalVempAmount} />
            <CardValue
              value={Number(vempDetails?.tokenPrice) * Number(totalVempAmount)}
              prefix="$"
              decimals={2}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "80%",
            margin: "auto",
            marginBottom: "40px",
          }}
        >
          <Label style={{ fontSize: "20px", color: "white", fontWeight: 100 }}>
            {TranslateString(546, "VEMP in Wallet")}
          </Label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: "18px",
              color: "white",
              fontWeight: 100,
            }}
          >
            <CakeWalletBalance cakeBalance={cakeBalance} />
            <CardValue
              value={Number(vempDetails?.tokenPrice) * cakeBalance}
              prefix="$"
              decimals={2}
            />
          </div>
        </div>
        <Actions>
          {localStorage.getItem("account") ? (
            <div style={{ width: "64%", margin: "auto" }}>
              <Button
                // id="harvest-all"
                className="tokenHarvestBorder button"
                disabled={balancesWithValue.length <= 0 || pendingTx}
                onClick={harvestAllFarms}
                fullWidth
              >
                {pendingTx
                  ? TranslateString(548, "Collecting EGG")
                  : TranslateString(
                      999,
                      `Harvest all (${balancesWithValue.length})`
                    )}
              </Button>
            </div>
          ) : (
            <div style={{ width: "64%", margin: "auto" }}>
              <Button
                className="tokenHarvestBorder button"
                onClick={onPresentConnectModal}
              >
                {TranslateString(292, "Unlock Wallet")}
              </Button>
            </div>
          )}
        </Actions>
      </CardBody>
    </StyledFarmStakingCard>
  );
};

export default FarmedStakingCard;
